import { defineReceiver } from '@drapejs/invoker';
import { fetchStories } from '@distancify/drapejs-storyblok';
import { fetchPage } from '@drapejs/core';

export const loadBlogReceiver = defineReceiver(
  fetchPage,
  async function (command, data) {
    if (!isBlogPage(data) && !hasNewsBlock(data)) {
      return data;
    }
    const articles = await this.invoke(fetchStories, {
      starts_with: 'nyheter/',
      is_startpage: false,
      sort_by: 'first_published_at:desc',
    });

    this.cache.setItem('__blog', articles);

    return data;
  }
);

function hasNewsBlock(data: any) {
  const blocks = data?.blocks || [];
  return blocks.find((block: any) => block.component === 'News');
}

function isBlogPage(data: any) {
  const component = data?.component?.toLowerCase();
  return component && component.indexOf('blog') >= 0;
}
